import React from "react";
import { Box, Button, Divider, Typography } from "@mui/material";

function NotFoundPage() {
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 8,
          pb: 10,
        }}
      >
        <Typography variant="h3">Oops.. Something is wrong.</Typography>
        <img src="/travolta.gif" alt="Not Found" />
        <Button href="/" sx={{ mt: 4 }} variant="contained">
          Back to safety
        </Button>
      </Box>
      <Divider />
      <Typography
        width={"100%"}
        display="block"
        variant="caption"
        sx={{ textAlign: "center", p: 1 }}
      >
        MyUserPrompt&copy; 2025
      </Typography>
    </React.Fragment>
  );
}

export default NotFoundPage;
